import { api } from "@/api";
import { ChatWidgetTurnFeedback } from "@/types";

export type FeedbackRating = "positive" | "negative";

export interface UpsertFeedbackRequestBody {
  user_id: string;
  turn_id: string;
  rating?: FeedbackRating | null;
  message?: string | null;
}

export interface FeedbackApiResponse {
  feedback: ChatWidgetTurnFeedback | null;
  deleted?: boolean;
}

/**
 * Upsert feedback for a system turn.
 * - If both rating and message are provided as empty/null, existing feedback is deleted.
 */
export async function upsertFeedback(
  siteId: string,
  body: UpsertFeedbackRequestBody,
): Promise<{ data?: FeedbackApiResponse; error?: string }> {
  return api.post<FeedbackApiResponse>(
    `/${siteId}/chat-widget/feedback/`,
    body,
  );
}

/** Update resolved status of a feedback item */
// Note: Authenticated "resolved" update is not supported in the public widget.
